module.exports = __webpack_public_path__ + "static/media/elements_section2_slide1.1be97b7e.png";